var _defs, _title, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 514.45 173.11",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    transform: "translate(-29.32 -43.87)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -186.84,
    y: -221.81,
    width: 1280,
    height: 1000
  })))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "afnu-logo-vector")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.39,136.41v-41.95h-12.12c-5.68,0-10.28-4.6-10.28-10.28v-21.13h22.41v-9.01c0-34.27,19.33-54.04,51.62-54.04,18.01,0,33.61,5.71,45.91,19.11l-19.77,23.28c-4.39-6.15-10.32-10.1-17.57-10.1-9.88,0-15.38,6.59-15.38,19.77v10.98h36.46v31.41h-35.8v78.64h-45.47v-36.68h0Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.68,136.41v-58.21c0-8.37,6.79-15.16,15.16-15.16h30.31v26.36c6.59-17.57,21.97-30.75,43.49-30.75,22.62,0,37.78,13.18,37.78,46.79v67.66h-45.47v-57.99c0-14.72-5.93-21.09-16.03-21.09-11.2,0-18.01,7.69-19.77,18.01v61.07h-45.47v-36.68h0Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.72,124.99v-51.04c0-8.08,6.55-14.63,14.63-14.63h30.83v57.99c0,14.72,5.93,21.09,15.6,21.09,11.42,0,18.23-8.35,19.99-23.06v-41.38c0-8.08,6.55-14.63,14.63-14.63h31.05v113.78h-45.69v-30.31c-6.15,16.25-22.19,30.31-42.61,30.31-22.84,0-38.44-13.62-38.44-48.11h0Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.27,96.05c2.67-11.79,3.87-24.05,3.91-36.24h32.79c.06,8.29-.57,16.87-1.73,24.89-1.58,12.47-4.32,24.37-8.56,36.17-4.67,12.44-10.52,23.33-19.54,33.09-14.8,16.02-35.39,22.81-56.76,17.18-12.85-3.38-24.64-11.73-32.37-22.57-12.27-17.2-14.39-39.83-5.83-59.12,7.1-16,21.16-28.04,38.2-32.22,13.33-3.27,27.2-1.86,39.41,4.11,3.08,1.51,5.58,3.39,7.82,5.98-.38,12.73-2.14,25.94-6.71,37.91-7.42-10.67-20.13-17.49-32.78-13.88-5.34,1.52-9.97,5.1-12.81,9.92-6.81,11.58-3.23,27.33,9.03,34.07,7.48,4.11,16.49,3.53,23.61-1.08,6.2-4.01,10.85-9.61,14.22-16.15,3.64-7.07,6.29-14.1,8.08-22.07h.02Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.52,111.46s-9.59,42.2-45.46,61.64h45.92s-.99-61.64-.46-61.64Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.07e11a2e.svg";
export { ForwardRef as ReactComponent };